import { Routes, Route, Outlet, Link } from "react-router-dom";
import { adminRoutes, connectedRoutes, publicRoutes, superAdminRoutes } from "./Routes";
import { AdminProtected } from "./AdminProtected";
import { UserProtected } from "./UserProtected";
import { SuperAdminProtected } from "./SuperAdminProtected";

export default function Navigation() {
  return (
    <>
      <Routes>
        {/* admin */}
        {superAdminRoutes.map((route, i) => (
          <Route
            key={i}
            path={route.path}
            element={<SuperAdminProtected>{route.component}</SuperAdminProtected>}
          />
        ))}
        {adminRoutes.map((route, i) => (
          <Route
            key={i}
            path={route.path}
            element={<AdminProtected>{route.component}</AdminProtected>}
          />
        ))}

        {connectedRoutes.map((route, i) => (
          <Route
            key={i}
            path={route.path}
            element={<UserProtected>{route.component}</UserProtected>}
          />
        ))}

        {publicRoutes.map((route, i) => (
          <Route
            key={i}
            path={route.path}
            element={route.component}
          />
        ))}
      </Routes>
    </>
  );
}
